import { useTranslation } from 'react-i18next';

import { Skeleton } from '../ui/Skeleton';

import styles from './AuthSkeleton.module.css';

/**
 * What a guard renders while the boot refresh is in flight. It occupies the same
 * shape the auth card will, so the page does not jump when the answer arrives.
 */
export function AuthSkeleton() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.wrap} role="status" aria-live="polite" data-testid="auth-hydrating">
      <span className="visually-hidden">{t('app.loading')}</span>
      <Skeleton width="12rem" height="3rem" />
      <div className={styles.card}>
        <Skeleton height="1.5rem" width="60%" />
        <Skeleton height="2.75rem" />
        <Skeleton height="2.75rem" />
        <Skeleton height="3.25rem" />
      </div>
    </div>
  );
}
